<template>
  <div
    class="card"
    id="payment-transfer-chart"
  >
    <div class="card-header border-bottom">
      <h5 class="card-title">
        {{ $t('Sales by payment type') }}
      </h5>
    </div>
    <div class="card-body">
      <v-chart
        v-if="isLoaded"
        class="chart"
        :option="option"
        autoresize
      />
      <div
        class="legend-area d-flex justify-content-center"
        id="custom-legend"
      >
        <div
          class="d-flex align-items-center px-15 legend-item "
          v-for="(item,index) in customLegendVal"
          :class="[index != customLegendVal.length - 1 ? 'border-right' : '']"
          :key="item.id"
        >
          <div
            class="new-marker"
            :style="{ backgroundColor: item.color}"
          /> {{ $t(item.name) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "@/plugins/vue-echarts";
import VueJsCounter from "@/plugins/VueJsCounter";
import { localRead } from "@/store/lang";
import moment from "moment";
import numeral from "numeral";

use([
    CanvasRenderer,
    PieChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
]);

export default {
    name: "ChartPayment",
    components: {
        VChart,
        // VueJsCounter,
    },
    provide: {
        [THEME_KEY]: "default",
    },
    props:['pieChart','filterDate'],
    data() {
        let vm = this;
        return {
            duration: 2000,
            lang: localRead("local"),
            isLoaded:false,
            option : {
                tooltip: {
                    trigger: 'item',
                    axisPointer: {
                        type: "shadow",
                    },
                    // position: function (pos, params, dom, rect, size) {
                    //     // tooltip will be fixed on the right if mouse hovering on the left,
                    //     // and on the left if hovering on the right.
                    //     var obj = {top: 60};
                    //     obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
                    //     return obj;
                    // },
                    padding: 0,
                    borderColor:"#f8f9fa",
                    formatter : function (params) {
                        
                        const {data} = params
                        const total = '฿'+Number(data.total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                        const value = numeral(data.value).format("0,0");
                        const name = vm.$t(params.name == "COD" ? '_Salepage.COD' : params.name)
                        return `<div class="mb-1 p-0 border-0 " style="width:237px;height:100%">
                                <div class="bg-light border-bottom p-2">
                                    <div class='d-flex align-items-center'>
                                        <div  class="mr-2"
                                            style="background-color:${params.color};width:10px;height:10px;border-radius: 1px;">
                                        </div>
                                        <span>${name}</span>
                                    </div>
                                </div>
                            
                                <div class="p-2" style="font-size:12px">
                                    <div class='d-flex justify-content-between'>
                                        <span>${data.date}</span>
                                    </div>
                                    <div class='d-flex justify-content-between'>
                                        <span>${vm.$t('Number of orders')}</span>
                                        <span><b>${value}</b></span>
                                    </div>
                                    <div class='d-flex justify-content-between '>
                                        <span>${vm.$t('Sales')}</span>
                                        <span><b>${total}</b></span>
                                    </div>
                                </div>
                            </div>`;
                    }
                },
                legend: {
                    // top: '5%',
                    orient: 'horizontal',
                    // left: 'right',
                    // textAlign : 'center',
                    // right: 380,
                    // top: 20,
                    itemWidth:15,
                    itemHeight:15,
                    bottom: '2%',
                    itemGap:25,
                    icon: "rect",
                    show:false
                },
                series: [
                    {
                    name: 'Access From',
                    type: 'pie',
                    radius: ['50%', '85%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 1
                    },
                    emphasis: {
                        label: {
                            show: true,
                            formatter:(params) => {
                                const {data} = params
                                const name = vm.$t(params.name == "COD" ? '_Salepage.COD' : params.name)
                                const centralVal  = numeral(data.value).format("0,0");
                                return '{b|'+name+'}\n{value|'+centralVal+'}\n{order|'+vm.$t('Orders')+'}';
                            },
                            rich:{
                                b:{
                                    fontWeight:'bold',
                                    fontSize:16
                                },
                                value:{
                                    fontWeight:'bold',
                                    fontSize:32,
                                    lineHeight:40
                                },
                                order : {
                                    fontSize:16,
                                    color:"#A2A3A5"
                                }
                            }
                        },
                      
                        
                    },
                    labelLine: {
                        show: false
                    },
                    data: [
                        { value: 1048, name: 'Search Engine' },
                        { value: 735, name: 'Direct' },
                        { value: 580, name: 'Email' ,something : 'wtf' },
                    ]
                    }
                ],
                color : ["#00337C","#0081C9","#03C988","#5BC0F8","#FFC93C","#1D1CE5","#4649FF","#C47AFF","#006C9A","#00BEBE", "#00F3E4", "#9FF9C1"]
                
            },
            hasData: false,
            customLegendVal:[]
        };
    },
    mounted() {
        const color = ["#00337C","#0081C9","#03C988","#5BC0F8","#FFC93C","#1D1CE5","#4649FF","#C47AFF","#006C9A","#00BEBE", "#00F3E4", "#9FF9C1"]
        const data = []
        const filterDateFormat = this.filterDate2String()
        // console.log({filterDateFormat});
        for ( const [key,value] of Object.entries(this.pieChart)) {
            value.date = filterDateFormat
            value.color = color[value.id-1]
            data.push(value)
        }
      
        this.option.series[0].data = data
        this.option.color = data.map(item => color[item.id-1])
        this.customLegendVal = data.map(item => ({
            color:item.color,
            name:item.name == "COD" ? '_Salepage.COD' : item.name,
            id:item.id
        }))
      
        this.isLoaded = true
    },
    methods:{
        filterDate2String(){

            const startDate = moment(this.filterDate.startDate, "YYYY-MM-DD").locale(this.lang).format("DD MMM YYYY")
            const startDateNoYear = moment(this.filterDate.startDate, "YYYY-MM-DD").locale(this.lang).format("DD MMM")
            const endDate = moment(this.filterDate.endDate, "YYYY-MM-DD").locale(this.lang).format("DD MMM YYYY")
          
            if(moment(this.filterDate.startDate).isSame(this.filterDate.endDate,'year')) {
                return startDateNoYear + " - " + endDate
            } else {
                return startDate + " - " + endDate
            }
        }
    },
};
</script>

<style scoped>
.chart {
    height: 310px;
}
.no-data {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.25;
    font-size: 1.5em;
    text-align: center;
}
.new-marker{
    width:15px;
    height:15px;
    border-radius: 1px;
    margin-right: 11px;
}

.legend-item{
    height: 36px;
}
.legend-item.border-right{
    border-right: 1px  solid #E6E7F1 !important;
}
.maker-line{
    border-left: 1px  solid #E6E7F1;
    height: 36px;
}
.px-15{
    padding-left: 15px;
    padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/ChartPiePayment.vue